import { useEffect } from "react";

// Injects a `noindex, nofollow` robots meta tag for the lifetime of the
// calling component. Used by internal-only pages that must never be indexed.
export function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
}
